import { Service } from "models/Service";
import {
  getClipping,
  getDataImageFromRelated,
  getDataImageSelectedFromRelated,
  getWeekDayCommaDayMonthDayYear
} from "helpers";
import axios from "axios";
import { voices } from "./voices";
import {items} from "./data";

// Configuración del proxy basada en las variables de entorno
const useProxy = process.env.USE_PROXY === 'true';
const proxy = useProxy
    ? {
        protocol: 'http',
        host: process.env.PROXY_HOST,
        port: parseInt(process.env.PROXY_PORT, 10)
    }
    : false;

export class AudioPlayer extends Service {
  constructor() {
    super({
      adsPath: "servicios/home",
      meta: {
        description: `Audio - Clarin.com`,
        keywords: "",
        title: `Audio - Clarin.com`,
        url: `playlist`,
        extra: [{ name: "robots", content: "noindex" }],
      },
      section: "playlist",
      sectionName: "playlist",
      template: "AudioPlaylist",
      title: "Playlist",
      slug: "",
      titleHeader: "",
      widthFull: true,
      width100: true,
      bannersOn: false,
      enableHeader: false,
      enableFooter: false,
      autorefresh: false
    });
  }

  createContent = async (data) => {

    try {
      const response = await axios({
        url: `${process.env.NEXT_PUBLIC_API_POWERBEANS}/private/contents?includeProcessingAudios=true&apiKey=${process.env.NEXT_PUBLIC_API_KEY_POWERBEANS}`,
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: process.env.NEXT_PUBLIC_DOMAIN_URL,
          "Powerbeans-url": data.url,
        },
        ...(useProxy && { proxy }),
        data: JSON.stringify(data),
      });
      if (response?.data?.audios?.length > 0) {
        const audio = response.data.audios
          .reverse()
          .find((audio) => audio.fullAudioUrl);
        audio._id = response.data?._id ?? "";
        audio.updatedAt = response.data?.updatedAt ?? "";
        return audio;
      } else if (response?.data?.message?.includes('ContentId')) {
        const audio = this.getContentByIdInMessage(response?.data?.message, data);
        return audio
      }
      throw new Error("No se pudo crear el contenido en powerbeans");
    } catch (error) {      
      console.log("Error create content powerbeans", error.response?.data ?? error.message);
      if(error.response?.data?.message) {
        const audio = this.getContentByIdInMessage(error.response?.data?.message, data);      
        return audio
      }
    }
  };

  updateContent = async (data, audioId) => {
    try {
      const response = await axios({
        url: `${process.env.NEXT_PUBLIC_API_POWERBEANS}/private/contents/${audioId}?includeProcessingAudios=true&apiKey=${process.env.NEXT_PUBLIC_API_KEY_POWERBEANS}`,
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: process.env.NEXT_PUBLIC_DOMAIN_URL,
          "Powerbeans-url": data.url,
        },
        ...(useProxy && { proxy }),
        data: JSON.stringify(data),
      });
      if (response?.data?.audios?.length > 0) {
        const audio = response.data.audios
          .reverse()
          .find((audio) => audio.fullAudioUrl);
        audio._id = response.data?._id ?? "";
        audio.updatedAt = response.data?.updatedAt ?? "";
        return audio;
      }
    } catch (error) {
      console.log("Error update content powerbeans", error.response?.data ?? error.message);
    }
  };

  getContentByIdInMessage = async (message, data) => {
    try {
      let contentId = message.split('ContentId: ')[1];
      const contentAudio = await this.getContent(data, contentId);
      const audio = contentAudio.audios
        .reverse()
        .find((audio) => audio.fullAudioUrl);
      audio._id = contentAudio?._id ?? "";
      audio.updatedAt = contentAudio?.updatedAt ?? "";
      return audio      
    } catch (error) {
      console.log("Error get content by id in message", error.message);
    }
  }  

  getContent = async (data, audioId) => {
    try {
      const response = await axios({
        url: `${process.env.NEXT_PUBLIC_API_POWERBEANS}/private/contents/${audioId}?includeProcessingAudios=true&apiKey=${process.env.NEXT_PUBLIC_API_KEY_POWERBEANS}`,
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Origin: process.env.NEXT_PUBLIC_DOMAIN_URL,
          "Powerbeans-url": data.url,
        },
        ...(useProxy && { proxy }),
      })
      return response?.data?.[0];
    } catch (error) {
      console.log("Error get content powerbeans", error.response?.data ?? error.message);
    }
  };

  getDataBucket = () => {
    
      const data = items;
      return {
        news: data?.length > 0 ? data : null,
        name: data?.name ? data?.name : null,
        publishedDate: data?.publishedDate
          ? data?.publishedDate
          : null,
      };
    
  };

  getPlainTextForContent = (bodyNews = [], authorName = "REDACCIÓN CLARIN") => {
    const bodyNewsText = bodyNews
      .map((content) => (content?.type == "text" ? content.value : ""))
      .join(" ");
    const bodyNewsTextWithOutHtml = bodyNewsText
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ");
    return `Por: ${authorName}. ${bodyNewsTextWithOutHtml} Fin de nota.`;
  };

  parseDataForApiPowerbeans = (news, content) => {
    return {
      text: {
        title: news.value?.title,
        content: content,
      },
      url: `${process.env.NEXT_PUBLIC_DOMAIN_URL}${news.value?.url}`,
      originalLanguage: "es",
      voices: voices?.[news?.value?.authors?.[0]?.slug] ? [voices[news.value.authors[0].slug]] :  ["Claudio"],
    };
  };

  getImageUrl = (news) => {
    const dataImageManualCrop = getDataImageSelectedFromRelated(
      news.value?.related
    );
    if (dataImageManualCrop.image && dataImageManualCrop.image !== "#") {
      return dataImageManualCrop.image;
    }
    const image = getClipping(
      ["rectangle_lg", "rectangle_sm"],
      getDataImageFromRelated(news.value?.related).clippings
    );
    return image?.image ? image.image : "";
  };

  getUrlVodepLoop = (news) => {
    const entityId = news.value?.related?.videos?.[0]?.value?.entityId
      ? news.value?.related?.videos?.[0]?.value?.entityId
      : "";
    return entityId
      ? `https://cdn.jwplayer.com/v2/media/${entityId}/poster.mp4?width=640`
      : "";
  };

  getAudioByIdNews = async (idNews) => {
    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_API_AUDIO_STORE}/${idNews}`, {
        method: 'GET',
      });
      const data = await response.json();
      return data?.items?.[0]?.data ? data.items[0].data : {};
    } catch (error) {
      console.log("Error get audio by id news", error.message);
    }
  };

  savedAudio = async (data) => {
    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_API_AUDIO_STORE}`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      });
    
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.log("Error saved audio", error.message);
    }
  };

  updateAudio = async (data) => {
    try {
      const response = await fetch(`${process.env.NEXT_PUBLIC_API_AUDIO_STORE}/${data.userId}`, {
        method: 'PUT',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.log("Error update audio", error.message);
    }
  };

  getAudio = async (item) => {
    try {
      const content = this.getPlainTextForContent(
        item.value?.body,
        item?.value?.authors?.[0]?.name
      );
      const audioSaved = await this.getAudioByIdNews(item._id);
      if (audioSaved?.audioSrc) {
        // const modificatedAtNews = new Date(item.value?.modificatedAt);
        // const modificatedAtUpdate = new Date(audioSaved.updatedAt);
        // if (
        //   modificatedAtNews.getTime() > modificatedAtUpdate.getTime() &&
        //   audioSaved?._id
        // ) {
        //   const audioUpdate = await this.updateContent(
        //     this.parseDataForApiPowerbeans(item, content),
        //     audioSaved._id
        //   );
        //   if (audioUpdate._id) {
        //     await this.updateAudio({
        //       userId: item._id,
        //       data: {
        //         _id: audioUpdate._id,
        //         audioSrc: audioUpdate.fullAudioUrl,
        //         updatedAt: audioUpdate.updatedAt,
        //       },
        //     });
        //   }
        // }
        return audioSaved.audioSrc;
      }
      // const audio = await this.createContent(
      //   this.parseDataForApiPowerbeans(item, content)
      // );
      // if (audio._id) {
      //   await this.savedAudio({
      //     userId: item._id,
      //     data: {
      //       _id: audio._id,
      //       audioSrc: audio.fullAudioUrl,
      //       updatedAt: audio.updatedAt,
      //     },
      //   });
      // }
      // return audio?.fullAudioUrl ? audio.fullAudioUrl : "";
    } catch (error) {
      console.log("Error get audio", error.message);
    }
  };

  getPlaylist = async (news) => {
    const dataPlaylist = await Promise.all(
      news.map(async (item) => {
        const audio = await this.getAudio(item);
        const parseAudio = audio?.replace("https://audios.powerbeans-ai.com", "https://audioplaylist.clarin.com")
        const imageUrl = this.getImageUrl(item);
        const urlVideoLoop = this.getUrlVodepLoop(item);
        const indexFirstParagraph = item.value?.body?.findIndex(
          (content) => content.type === "text"
        );
        
        return {
          audio: parseAudio,
          author: item?.value?.authors?.[0]?.name
            ? item.value.authors[0].name
            : "REDACCIÓN CLARIN",
          firstParagraph:
            item.value?.body?.[indexFirstParagraph]?.value?.replace(
              /(<([^>]+)>)/gi,
              ""
            ) ?? "",
          imageSrc: imageUrl,
          summary: item.value?.summary ? item.value.summary : "",
          title: item.value?.title ? item.value.title : "",
          videoLoop: "",
        };
      })
    );
    return dataPlaylist.filter((item) => item.audio);
  };

  parseData = async (query) => {
    let playlist = [];
    // try {
      playlist = await this.getPlaylist(items.items);
      const parseDate = getWeekDayCommaDayMonthDayYear(items?.publishedDate);
      this.setData({
        news: playlist,
        name: items?.name,
        publishedDate: parseDate,
      });
    // } catch (error) {
    //   console.log("Error al crear la playlist.", error.message);
    // }
  };
}
